// prettier-ignore
export default {
  iconByCategory: {
    MEDICATION: 'medicine',
    CONDITION: 'guide',
    PROCEDURE: 'outliner-detection',
    LABORATORY: 'computer-select-test',
    VITALS: 'icon-ir',
    ALLERGY: 'benefits',
    IMMUNIZATION: 'immunology',
    'SOCIAL-HISTORY': 'unified-workflow'
  },
  diseaseSummary: {
    ALL_PANELS: ['geneObservationPanel', 'observationPanel', 'labPanel', 'molecularDiagnostic', 'biomarker', 'molecularDiagnosticPanel'],
    LAB_PANELS: ['observationPanel', 'labPanel'],
    GENE_PANELS: ['geneObservationPanel', 'molecularDiagnostic', 'biomarker', 'molecularDiagnosticPanel', 'biomarkerPanel'],
    GRAPH_TYPES: ['labResult', 'performanceStatus', 'vitalSigns'],
    GROUPED_ON_TIMELINE: ['biomarker', 'performanceStatus', 'molecularDiagnostic', 'vitalSigns', 'labResult'],
    ENTITY_SPECIFIC_VIEWS: ['labResult', 'performanceStatus', 'observationPanel', 'labPanel', 'geneObservationPanel', 'molecularDiagnosticPanel', 'biomarkerPanel', 'vitalSigns'],
    DEVELOPMENT_ENTITIES: ['grossMotorDevelopment', 'fineMotorDevelopment', 'languageDevelopment', 'academicPerformance'],
    LIQUID_DIAGNOSIS_ORPHANS: ['diagnosticProcedure', 'medication', 'treatmentGroup', 'biomarker', 'labResult', 'molecularDiagnostic', 'performanceStatus', 'biomarkerPanel'],
    SOLID_DIAGNOSIS_ORPHANS: ['diagnosticProcedure', 'medication', 'treatmentGroup', 'biomarker', 'labResult', 'performanceStatus', 'biomarkerPanel'],
    ORPHANS: ['diagnosticProcedure', 'medication', 'treatmentGroup', 'biomarker', 'labResult', 'performanceStatus', 'molecularDiagnostic', 'biomarkerPanel'],
    ENTITIES_TO_FILTER: ['biomarker', 'molecularDiagnostic', 'treatmentGroup', 'labResult',
      'performanceStatus', 'grossMotorDevelopment', 'fineMotorDevelopment', 'languageDevelopment', 'puberty',
      'seizureType', 'seizureFrequency', 'device', 'standardizedAssessmentParent', 'standardizedAssessmentChild',
      'fineMotorAssistiveDevice', 'grossMotorAssistiveDevice',
      'assistiveCommunicationDevice', 'activeWristExtensionSplint', 'academicPerformance'],
    CATEGORIES_TO_FILTER: ['physical-exam', 'hospital-admission'],
    HOSPITAL_ADMISSION: ['admissionDiagnosis'],
    PHYSICAL_EXAMS: ['gait', 'coordination', 'reflexes', 'sensationFindings', 'muscleToneFindings', 'muscleStrengthBulkFindings',
      'cranialNerveFindings', 'fundusExam', 'slitLampExam', 'strabismus', 'extraocularMovements', 'visualFields', 'pupils',
      'intraocularPressure', 'visualAcuity']
  },
  idVerificationTitle: 'Identity verification required',
  idVerificationMsg: 'You must verify your identity before requesting records',
}
